import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxntDynamicComponent } from './rxnt-dynamic.component';

@NgModule({
  declarations: [
    RxntDynamicComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntDynamicComponent,
  ],
})
export class RxntDynamicModule {
}
